const translations = {
    allUnits: 'All units',
    noUnitsFound: 'No units found.',
    search: 'Search'
};

export default translations;
